import { FC } from 'react';
import { Hits } from 'react-instantsearch';
import { withCollecitonHitNormalization } from '../../../shared/hoc';
import { AlgoliaCollectionHit } from '../../../shared/types';
import { AlgoliaUtil } from '../../../shared/utils';
import { Hit } from './components';

type CollectionsSectionProps = {
  algoliaUtil: AlgoliaUtil;
  mobile: boolean;
};

export const CollectionsSection: FC<CollectionsSectionProps> = ({ algoliaUtil, mobile }) => {
  return (
    <div className="sr-collections-container" style={{ minHeight: '260px' }}>
      {mobile ? null : <h3 className="title">{theme.locales.collections}</h3>}

      <Hits
        hitComponent={({ hit }) =>
          withCollecitonHitNormalization(Hit)({
            hit: hit as unknown as AlgoliaCollectionHit,
            normalizeHit: algoliaUtil.normalizeCollectionHit,
          })
        }
      />
    </div>
  );
};
